import Http from 'services/Http';
import computeContentMd5Base64 from 'utils/computeContentMd5Base64';
import parseFileName from 'utils/getFileExtension';
import toURIParams from 'utils/toURIParams';

class Channel {
  async find(id) {
    const { data } = await Http.get(`/v1/group/${id}`);
    return data.group;
  }

  async list() {
    const { data } = await Http.get('/v1/group');
    return data;
  }

  async create(form) {
    const response = await Http.post('/v1/group', form);
    return response.data.group;
  }

  async update(channelId, form) {
    const response = await Http.patch(`/v1/group/${channelId}`, form);
    return response.data.group;
  }

  async updatePreview(channelId, form) {
    const response = await Http.patch(`/v1/group/${channelId}/update-preview`, form);
    return response.data.group;
  }

  async join(channelId) {
    const response = await Http.patch(`/v1/group/${channelId}/join`);
    return response.data.group;
  }

  async upload(id, avatar) {
    const { type: mimeType, name } = avatar;
    const { ext } = parseFileName(name);
    const contentMd5 = await computeContentMd5Base64(avatar);
    try {
      const { data } = await Http.post(`/v1/group/${id}/avatar/sign-url`, {
        mimeType,
        ext,
        contentMd5,
      });
      await Http.putS3(data.url || data.uploadUrl, avatar, {
        headers: { 'Content-Type': mimeType, 'Content-MD5': contentMd5, ...(data.headers || {}) },
        timeout: 0,
      });
      const uploaded = await Http.patch(`/v1/group/${id}/avatar/uploaded`, { id: data.id });
      return uploaded.data;
    } catch (err) {
      if (err.status === 409) {
        const form = new FormData();
        form.append('avatar', avatar);
        const { data } = await Http.post(`/v1/group/${id}/file`, form);
        return data;
      }
      throw err;
    }
  }

  async destroy(id) {
    const { data } = await Http.delete(`/v1/group/${id}`);
    return data;
  }

  async setArchived(id, archived) {
    const { data } = await Http.patch(`/v1/group/${id}/${archived ? '' : 'un'}archive`);
    return data;
  }

  async setMuted(id, muted) {
    const { data } = await Http.patch(`/v1/group/${id}/mute`, { muted });
    return data;
  }

  async setPinned(id, pinned) {
    const { data } = await Http.patch(`/v1/group/${id}/pinned`, { pinned });
    return data;
  }

  async getMemberChannels() {
    const { data } = await Http.get('/v1/group/member');
    return data;
  }

  async getMembers(id, { skip, limit, search, message }) {
    const params = { skip, limit, search, message };
    const queryString = toURIParams(params);
    const url = `/v1/group/${id}/members${queryString ? `?${queryString}` : ''}`;
    const { data } = await Http.get(url);
    return data;
  }
}

export default new Channel();
